const SLOT_LABELS = {
  1: "Entrada M",
  2: "Salida M",
  3: "Entrada T",
  4: "Salida T",
};

function formatTimeToAmPm(hh, mm) {
  const h = Number(hh);
  const m = Number(mm);
  if (!Number.isFinite(h) || !Number.isFinite(m) || h < 0 || h > 23 || m < 0 || m > 59) {
    return null;
  }
  const period = h >= 12 ? "PM" : "AM";
  const h12 = h % 12 === 0 ? 12 : h % 12;
  return `${String(h12).padStart(2, "0")}:${String(m).padStart(2, "0")} ${period}`;
}

function parsePlainTime(raw) {
  const match = /(?:a\s+las|hora\s+de\s+llegada(?:\s*(?:es|:))?)\s*(\d{1,2}):(\d{2})\s*([ap])\.?\s*m\.?/i.exec(raw);
  if (!match) return null;

  let hh = Number(match[1]);
  const mm = Number(match[2]);
  if (!Number.isFinite(hh) || !Number.isFinite(mm) || hh < 1 || hh > 12 || mm < 0 || mm > 59) {
    return null;
  }
  if (match[3].toLowerCase() === "a") hh = hh === 12 ? 0 : hh;
  if (match[3].toLowerCase() === "p") hh = hh === 12 ? 12 : hh + 12;
  return { hh, mm };
}

export function parseHorasPreviewFromJustificacion(text, allowPlainTime = false) {
  const raw = String(text || "").trim();
  if (!raw) return [];

  const metadata = /HORAS:([0-9,:]+)/i.exec(raw);
  if (metadata?.[1]) {
    return metadata[1]
      .split(",")
      .map((part) => part.trim())
      .filter(Boolean)
      .map((part) => {
        const pieces = part.split(":");
        if (pieces.length < 4) return null;
        const slot = Number(pieces[0]);
        const estado = Number(pieces[1]);
        const hh = Number(pieces[2]);
        const mm = Number(pieces[3]);
        const hora = formatTimeToAmPm(hh, mm);
        if (!Number.isFinite(slot) || !hora) return null;
        return {
          slot,
          estado: estado === 1 ? "ok" : "off",
          label: SLOT_LABELS[slot] || `Marca ${slot}`,
          hora,
          minutesOfDay: hh * 60 + mm,
        };
      })
      .filter((slot) => slot?.estado === "ok")
      .sort((a, b) => a.minutesOfDay - b.minutesOfDay || a.slot - b.slot);
  }

  if (!allowPlainTime) return [];

  const time = parsePlainTime(raw);
  if (!time) return [];

  const lower = raw.toLowerCase();
  const isAfternoon = /\btarde\b/.test(lower);
  const isExit = /\bsalida\b/.test(lower);
  const slot = isExit ? (isAfternoon ? 4 : 2) : isAfternoon ? 3 : 1;
  return [{
    slot,
    estado: "ok",
    label: SLOT_LABELS[slot],
    hora: formatTimeToAmPm(time.hh, time.mm),
    minutesOfDay: time.hh * 60 + time.mm,
  }];
}
